<template>
  <div class="mt-7 mb-7">
    <h2 class="title mb-3">
      {{ $tc('wallet', 2) }}
      <svg-icon :icon="`pencil`" class="icon-xs ml-2" />
    </h2>
    <b-form>
      <b-form-group label="Epayments:" label-for="epayments">
        <b-form-label
          slot="label"
          label="Epayments:"
          for="epayments"
          :errors="errors.epayments"
        />
        <input-has-icon>
          <svg-icon icon="epayments" />
          <b-form-input
            id="epayments"
            type="text"
            required
            :placeholder="$t('enterWallet')"
            v-model="form.epayments"
            :state="errors.epayments ? false : null"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group label="Webmoney:" label-for="webmoney">
        <b-form-label
          slot="label"
          label="Webmoney:"
          for="webmoney"
          :errors="errors.webmoney"
        />
        <input-has-icon>
          <svg-icon icon="webmoney" class="twitter-color" />
          <b-form-input
            id="webmoney"
            type="text"
            required
            :placeholder="$t('enterWallet')"
            v-model="form.webmoney"
            :state="errors.webmoney ? false : null"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group label="Paxum:" label-for="paxum">
        <b-form-label
          slot="label"
          label="Paxum:"
          for="paxum"
          :errors="errors.paxum"
        />
        <input-has-icon>
          <svg-icon icon="paxum" class="twitter-color" />
          <b-form-input
            id="paxum"
            type="text"
            required
            :placeholder="$t('enterWallet')"
            v-model="form.paxum"
            :state="errors.paxum ? false : null"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group>
        <b-form-label
          slot="label"
          :label="$t('yandexMoney') + ':'"
          for="yandex"
          :errors="errors.yandex"
        />
        <input-has-icon>
          <svg-icon icon="yandex-pay" class="yandex-color" />
          <b-form-input
            id="uandex"
            type="text"
            required
            :placeholder="$t('enterWallet')"
            v-model="form.yandexMoney"
            :state="errors.yandex ? false : null"
          />
        </input-has-icon>
      </b-form-group>
      <b-form-group>
        <b-form-label
          slot="label"
          :label="$t('phoneNumber') + ' (' + $t('forRus') + ')'"
          for="phone"
          :errors="errors.phone"
        />
        <input-has-icon>
          <svg-icon icon="phone" class="twitter-color" />
          <b-form-input
            id="phone"
            type="text"
            required
            :placeholder="$t('enterPhoneNumber')"
            v-model="form.phone"
            :state="errors.phone ? false : null"
          />
        </input-has-icon>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import cloneDeep from 'clone';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        paxum: null,
        epayments: null,
        webmoney: null,
        phone: null,
        yandexMoney: null
      })
      // required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: cloneDeep(this.value)
    };
  },

  watch: {
    form: {
      deep: true,
      handler() {
        const emitData = cloneDeep(this.form);
        this.$emit('input', emitData);
      }
    }
  }
};
</script>
